import angular from 'angular';
import parseUrlParams from 'common/helpers/parse-url-params';

import { merge } from 'lodash';

module.exports = angular.module('common.services.paginate', [])
.factory('paginate', function($http) {
  var REL_REG = /rel=['"](.*?)["']/,
      HREF_REG = /<(.*?)>/,
      REPLACE = 'replace',
      APPEND = 'append', // eslint-disable-line no-unused-vars
      GREEDY = 'greedy';

  return function(paginatorMode, resourceParams, itemTransformFn) {
    return function(results, headerFn) {
      if (angular.isArray(results) && results.length) {
        var klass = results[0].constructor;
        results.$paginator = new Paginator(
          klass,
          results,
          headerFn(),
          paginatorMode,
          resourceParams,
          itemTransformFn
        );
      } else {
        delete results.$paginator;
        return results;
      }
    };
  };

  // paginator mode replace || append. Only use append if you're doing a more link
  //
  // @example
  //   Valuator.for_valuator({id: 5}, paginate()); // replaces
  //   Lead.summaries({}, paginate('append'));
  //
  //   leads.$paginator.$next
  //   leads.$paginator.$next()
  function Paginator(
    klass,
    values,
    headers,
    paginatorMode,
    resourceParams,
    itemTransformFn
  ) {
    this.mode = paginatorMode || REPLACE;
    this.klass = klass;
    this.actionName = values.$actionName;
    this.values = values;
    this.resourceParams = resourceParams || {};
    this.page = 1;
    this.itemTransformFn = itemTransformFn;
    this.reqInProgress = false;

    // mutable transformation since results.$paginator.values === results
    if (itemTransformFn) {
      values.forEach((item, index) => {
        values[index] = itemTransformFn(item);
      });
    }

    updateFromHeaders.call(this, headers);

    if (paginatorMode === GREEDY) {
      greedyCrawler.call(this);
    }

    this.greedyCrawler = greedyCrawler.bind(this);
  }

  function updateFromHeaders(headers) {
    this.total = headers['x-total'];
    this.perPage = headers['x-per-page'];
    addLinkAccessors.call(this, parseLinkHeaders(headers.link));
  }

  function greedyCrawler() {
    if (!this.$next) {
      return Promise.resolve();
    }
    return this.$next().then(() => {
      return greedyCrawler.call(this);
    });
  }

  function addLinkAccessors(links) {
    this.links = links;
    if (!links) return;

    links.forEach(function(link) {
      this['$' + link.rel] = followLinkFactory.call(this, link);
    }, this);
  }

  function removeLinkAccessors() {
    if (!this.links) return;

    this.links.forEach(function(link) {
      delete this['$' + link.rel];
    }, this);

    delete this.links;
  }

  function updateValues(data, headers) {
    removeLinkAccessors.call(this);
    updateFromHeaders.call(this, headers);
    if (this.mode === REPLACE) this.values.splice(0, this.values.length);

    const newValues = data.map(point => {
      let item = new this.klass(point);
      if (this.itemTransformFn) {
        return this.itemTransformFn(item);
      }
      return item;
    });

    Array.prototype.push.apply(this.values, newValues);
    return data;
  }

  function followLinkFactory(link) {
    if (this.actionName) {
      return () => {
        // prevent dup requests
        if (this.reqInProgress) {
          return;
        }
        this.reqInProgress = true;

        let params = merge({}, link.params, this.resourceParams);
        return this.klass[this.actionName](params, (data, headers) => {
          this.reqInProgress = false;
          return updateValues.call(this, data, headers());
        }).$promise;
      };
    }

    return () => {
      // prevent dup requests
      if (this.reqInProgress) {
        return;
      }
      this.reqInProgress = true;

      return $http.get(link.href).then((data, status, headers) => {
        this.reqInProgress = false;
        return updateValues.call(this, data, headers());
      });
    };
  }

  function parseLinkHeaders(strings) {
    var links = [];
    if (!strings) return links;

    var parts = strings.split(',');
    var rel, href;

    parts.forEach(function(part) {
      rel = part.match(REL_REG);
      href = part.match(HREF_REG);
      if (!rel || !href) return;

      var urlParams = parseUrlParams(href[1]);
      links.push({ rel: rel[1], href: href[1], params: urlParams });
    });
    return links;
  }

})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/paginate.js
 **/